import {
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, ViewEncapsulation
} from '@angular/core';
import { NgClass } from '@angular/common';

import { v4 as uuid } from 'uuid';
import { TranslateModule } from '@ngx-translate/core';

import {
  IconSizeEnum, PositionEnum, SdButtonComponent, SdButtonIconComponent, SdFormCheckboxComponent,
  SdIsCollapsibleDirective, SdListComponent, SdTitleComponent
} from '@seb/web-design-system/core';

import { IAddressCard } from './address-card.interface';

@Component({
  selector: 'sd-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdIsCollapsibleDirective,
    SdFormCheckboxComponent,
    NgClass,
    SdButtonIconComponent,
    SdListComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdAddressCardComponent implements OnInit {
  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;
  selected = false;
  isCardOpened = false;
  idCard: string = uuid();

  /**
   * Allow to define the level of the title tag (h1 - h6).
   * * @param {number} 1 to 6
   */
  @Input()
  titleLevel: number;

  @Input()
  title: string;

  @Input()
  address: IAddressCard;

  @Input()
  readOnly: boolean;

  @Input()
  inactive: boolean;

  @Input()
  showMainAddress = true;

  @Input()
  isSelectable = false;

  @Input()
  canChooseOther = true;

  @Input()
  checkboxLabel: string;

  @Input()
  pickupRepairChooseAction: string;

  @ViewChild('action', { read: ElementRef })
  action: ElementRef;

  @ViewChild('hide', { read: ElementRef })
  hide: ElementRef;

  @Output()
  addressSelected = new EventEmitter<void>();

  @Output()
  mainAddress = new EventEmitter<void>();

  @Output()
  edit = new EventEmitter<void>();

  @Output()
  switch = new EventEmitter<void>();

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.readOnly ? 'is-read-only' : '',
      this.inactive ? 'is-inactive' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }

  ngOnInit() {
    this.readOnly = this.address?.readonly
      ? this.address.readonly
      : this.readOnly;
    this.inactive = this.address?.inactive
      ? this.address.inactive
      : this.inactive;

    if (!this.pickupRepairChooseAction) {
      this.pickupRepairChooseAction = this.address?.repair
        ? 'checkout.address.actions.chooseOtherRepairLocation'
        : 'checkout.address.actions.chooseOtherPickupLocation';
    }
  }

  editAddress() {
    this.edit.emit();
  }

  otherAddress() {
    this.switch.emit();
  }

  setMainAddress() {
    this.mainAddress.emit();
  }

  updateCheckboxStatus() {
    this.addressSelected.emit();
  }

  toggle() {
    if (!this.readOnly && !this.inactive) {
      if (this.isSelectable) {
        this.selected = !this.selected;
      }
      this.addressSelected.emit();
    }
  }
}
